import '/modules/common/css/stats.css'
import {Base} from "./Base";
import {getUUID, nnTrim} from "./util";
import {formatTimestamp} from "./time/TimeCalculator";

/**
 * A UI usage statistics gatherer and sender
 * {UIElement} objects use this to log and this class automatically sends the stats to the server periodically
 * Shows a permission dialog to the user
 * Should be used as a singleton
 * @extends Base
 */
class StatsGatherer extends Base {

    /**
     *
     * @param appCode {string} The code of this application
     * @param postURL {string} The URL to post data to
     * @param target {jQuery} The target element for the user confirmation UI element
     */
    constructor(appCode, postURL, target) {
        super();
        this.postURL = postURL;
        this.appCode = appCode;
        this.target = target;

        this.code = localStorage.getItem("statsCode");
        this._readStatsMap();
    }

    getClassName() {
        return "StatsGatherer";
    }

    _readStatsMap() {
        const statsObjStr = localStorage.getItem("statsObject_" + this.appCode);
        this.statsMap = statsObjStr ? JSON.parse(statsObjStr) : {
            sessionStart: new Date(),
            map: {}
        };
    }

    _storeStatsMap() {
        localStorage.setItem("statsObject_" + this.appCode, JSON.stringify(this.statsMap));
    }

    _renderConfirmationElement() {
        if (!this.code) {
            const element = $(
                '<section id="stats_gatherer_container" aria-labelledby="stats_gatherer_header" class="stats-gatherer-container" role="dialog" aria-modal="true">' +
                '   <div class="stats-gatherer-header" id="stats_gatherer_header">' +
                tumbo.translator.translate('statsGatherer.confirmation.title') +
                '   </div>' +
                '   <div class="stats-gatherer-body">' +
                '       <div class="stats-gatherer-text">' +
                tumbo.translator.translate('statsGatherer.confirmation.text') +
                '       </div>' +
                '       <div class="stats-gatherer-buttons" aria-controls="stats_gatherer_container">' +
                '           <button class="action cancel-button">' + tumbo.translator.translate('statsGatherer.confirmation.cancel') + '</button>' +
                '           <button class="action accept-button">' + tumbo.translator.translate('statsGatherer.confirmation.accept') + '</button>' +
                '       </div>' +
                '   </div>' +
                '</section>'
            );
            $('button.cancel-button', element).click(() => element.hide());

            $('button.accept-button', element).click(() => {
                this.code = getUUID();
                localStorage.setItem('statsCode', this.code);
                element.hide();
            });
            this.target.append(element);
        }
    }

    /**
     * log an entry
     * @param element {UIElement|HelpElement}
     * @param action {string}
     * @param store {boolean} if true, store immediately
     */
    log(element, action, store = false) {
        this.logByCode(element.getCode(), nnTrim(element.getClassName(), element.getClass()), action, store);
    }

    /**
     * log an entry
     * @param code {string}
     * @param clazz {string}
     * @param action {string}
     * @param store {boolean} if true, store immediately
     */
    logByCode(code, clazz, action, store = false) {
        if (!this.statsMap.map[code])
            this.statsMap.map[code] = {type: clazz};
        if (!this.statsMap.map[code][action])
            this.statsMap.map[code][action] = {count: 0, firstExec: new Date()};
        this.statsMap.map[code][action].count++;
        this.statsMap.map[code][action].lastExec = new Date();
        if (store)
            this._storeStatsMap();
        this.lastActionTS = new Date();
    }

    _getStats2Post() {
        if (this.code) {
            const data = [['code', 'type', 'action', 'count', 'firstExec', 'lastExec']];
            Object.keys(this.statsMap.map).forEach(code => {
                const element = this.statsMap.map[code];
                Object.keys(element)
                    .filter(key => key !== 'type')
                    .forEach(action => {
                        data.push([code, element.type, action, element[action].count, element[action].firstExec, element[action].lastExec]);
                    });
            });
            return {
                code: this.code,
                sessionStart: this.statsMap.sessionStart,
                data: data
            };
        } else return {};
    }

    initSendProcedure() {
        this._renderConfirmationElement();
        if (!this.storeIntervalId)
            this.storeIntervalId = setInterval(() => this._storeStatsMap(), this.isMobile ? 10000 : 5000);

        if (!this.intervalId) {
            this.intervalId = setInterval(() => {
                if (this.code) {
                    if (this.lastActionTS && (!this.lastSendTS || this.lastActionTS > this.lastSendTS)) {
                        if (this.postURL) {
                            $.post(
                                this.postURL,
                                {data: JSON.stringify(this._getStats2Post())},
                                (data, textStatus, jqXHR) => {
                                    if (textStatus.toLowerCase() !== 'success')
                                        this.logError("Error posting stats: " + textStatus);
                                    this.lastSendTS = new Date();
                                    this.logDebug("Just posted stats");
                                }
                            ).fail((jqXHR, textStatus, errorThrown) => this.logError("Could not post stats [" + textStatus + "]", errorThrown));
                        } else if (new Date().getSeconds() % 25 === 0) {
                            this.logDebug('Would post stats', JSON.parse(JSON.stringify(this._getStats2Post())));
                            this.lastSendTS = new Date();
                        }
                    } else this.logDebug("Skipping post stats because there is no action more recent than {0}. Last was at {1}".format([formatTimestamp(this.lastSendTS,true),formatTimestamp(this.lastActionTS,true)]))
                }
            }, this.isMobile ? 30000 : 20000);
        }
    }
}

export {StatsGatherer}
